import $ from 'jquery';
import whatInput from 'what-input';
// import libs from './lib/deps';
window.$ = $;
// window.libs = libs;

import Foundation from 'foundation-sites';
// import swal from 'sweetalert2';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

var app = {
    init: function () {
        app.foundation();
        // app.svg();
        app.scroll();
        // app.gm();
        app.headerMenu();
        // app.slick();
        app.popup();
        app.locateMe();
        app.checkCookie();
        app.focusInput();
        app.checkbox();
        app.upload();
        app.readMore();
        app.loadmore();
        app.showmore();
        app.checkLangue();
    },
    showmore: function () {
        $('.show_more').hover(function () {
            var more = $(this).attr('data-more');
            $(this).next('.apla').text(more).toggle();
        });
    },
    loadmore: function () {
        $('#hideBtn').click(function () {
            $('html, body').animate({
                scrollTop: $('#offer').offset().top - 300
            }, 1000);
            $('.showed').delay(1000).slideToggle().removeClass('showed');
            $("#loadMore").show();
            $(this).hide();
        });
    },
    readMore: function () {
        $('.read-more-toggle').on('click', function () {
            $(this).toggleClass('rotate').next('.read-more-content').slideToggle();
            $(this).parent('.tire_descr').next('.tire').toggleClass('shrink');
        });
    },
    upload: function () {
        var FileUpload = function (el) {

            this.noValue = '&nbsp;';

            this.$container = $(el);
            this.$input = this.$container.find('input');
            this.$result = this.$container.next('.file-upload_result').html(this.noValue);

            this.getValue();
        };

        FileUpload.prototype.getValue = function () {

            var self = this;

            this.$input.on('change', function () {

                var valueArray = $(this).val().split('\\'),
                    value = valueArray[valueArray.length - 1];

                if (value.length === 0) {
                    self.$result.html(self.noValue);
                } else {
                    self.$result.html(value);
                }

                console.log(value);
            });
        };

        new FileUpload('.file-upload');
    },
    checkbox: function () {
        $("input[type='checkbox']").each(function () {
            $(this).on('click', function () {
                $(this).parent('div').toggleClass("item-select");
            });
        });
    },
    focusInput: function () {
        $(".form-group input").val("");

        $(".input-effect input").focusout(function () {
            if ($(this).val() !== "") {
                $(this).addClass("has-content");
            } else {
                $(this).removeClass("has-content");
            }
        });
    },
    foundation: function () {
        $(document).foundation();
    },
    svg: function () {
        $('img[src$=".svg"]').each(function () {
            var $img = jQuery(this);
            var imgURL = $img.attr('src');
            var attributes = $img.prop("attributes");

            $.get(imgURL, function (data) {
                var $svg = jQuery(data).find('svg');

                $svg = $svg.removeAttr('xmlns:a');

                $.each(attributes, function () {
                    $svg.attr(this.name, this.value);
                });

                $img.replaceWith($svg);
            }, 'xml');
        });
    },
    scroll: function () {
        $(function () {
            $('a[href*=\\#]:not([href=\\#])').click(function () {
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        $('html,body').animate({
                            scrollTop: target.offset().top - 100
                        }, 800);
                        return false;
                    }
                }
            });
        });
    },
    gm: function () {
        function getRequests() {
            var s1 = location.search.substring(1, location.search.length).split('&'),
                r = {}, s2, i;
            for (i = 0; i < s1.length; i += 1) {
                s2 = s1[i].split('=');
                r[decodeURIComponent(s2[0]).toLowerCase()] = decodeURIComponent(s2[1]);
            }
            return r;
        }
        ;
        var QueryString = getRequests();
        console.log(QueryString["q"]); //logs t1
        var pole = document.getElementById('searchinput');
        pole.value = QueryString["q"];
        google.maps.event.trigger(pole, 'place_changed');

        // initMap();

    },
    headerMenu: function () {
        $(".mobile-menu-container").find("li").each(function () {
            $(this).find("a").html(function (t, e) {
                // return e.replace(/ /g, " <br>")
            }).css("display", "block")
        }),
            $("#header__button").on("click", function (t) {
                t.preventDefault();
                $(this).toggleClass("hamburger--open");
                $(".mobile-menu-container").slideToggle()
            })
    },
    // slick: function () {
    //     console.log("slick zaladowany");
    //     // $("#slider1").slick();
    //
    //     $('.inside').slick({
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         arrows: false,
    //         fade: true,
    //         autoplay: true,
    //         autoplaySpeed: 3000,
    //         dots: true,
    //         // asNavFor: '.inside-nav',
    //         responsive: [
    //             {
    //                 breakpoint: 648,
    //                 settings: {
    //                     dots: false
    //                 }
    //             }
    //         ]
    //     });
    //
    //     // $('.inside-nav').slick({
    //     //     slidesToShow: 3,
    //     //     slidesToScroll: 3,
    //     //     asNavFor: '.inside',
    //     //     dots: false,
    //     //     arrows: false,
    //     //     vertical: true,
    //     //     centerMode: false,
    //     //     focusOnSelect: true,
    //     //     verticalSwiping: true,
    //     //     infinite: false,
    //     //     responsive: [
    //     //         {
    //     //             breakpoint: 992,
    //     //             settings: {
    //     //                 vertical: false,
    //     //                 verticalSwiping: true
    //     //             }
    //     //         }
    //     //     ]
    //     // });
    // },
    popup: function () {
        $('.overlay').on('click', function (e) {
            e.preventDefault();
            $(this).parent().fadeOut();
            window.location.href = window.location.href.split("?")[0];
        });
    },
    locateMe: function () {
        $('.locateme').on('click', function (e) {
            console.log("locateME poszlo");
            $(this).parents('form').submit();
        });
    },
    checkCookie: function () {
        if (!document.cookie.match(/^(.*;)?\s*allowed\s*=\s*[^;]+(.*)?$/)) {
            $('.cookie-popup').show();
        }
    },
    checkLangue: function () {
        const htmlLang = document.documentElement.lang;
        return htmlLang;
    },
    slugify: function (text, separator) {
        text = text.toString().toLowerCase().trim();
        const sets = [
            { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]' },
            { to: 'c', from: '[ÇĆĈČ]' },
            { to: 'd', from: '[ÐĎĐÞ]' },
            { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
            { to: 'g', from: '[ĜĞĢǴ]' },
            { to: 'h', from: '[ĤḦ]' },
            { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
            { to: 'j', from: '[Ĵ]' },
            { to: 'ij', from: '[Ĳ]' },
            { to: 'k', from: '[Ķ]' },
            { to: 'l', from: '[ĹĻĽŁ]' },
            { to: 'm', from: '[Ḿ]' },
            { to: 'n', from: '[ÑŃŅŇ]' },
            { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
            { to: 'oe', from: '[Œ]' },
            { to: 'p', from: '[ṕ]' },
            { to: 'r', from: '[ŔŖŘ]' },
            { to: 's', from: '[ßŚŜŞŠ]' },
            { to: 't', from: '[ŢŤ]' },
            { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
            { to: 'w', from: '[ẂŴẀẄ]' },
            { to: 'x', from: '[ẍ]' },
            { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
            { to: 'z', from: '[ŹŻŽ]' },
            { to: '-', from: '[·/_,:;\']' }
        ];
        sets.forEach(set => {
            text = text.replace(new RegExp(set.from, 'gi'), set.to);
        });
        text = text.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(/&/g, '-and-') // Replace & with 'and'
            .replace(/[^\w\-]+/g, '') // Remove all non-word chars
            .replace(/\--+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, ''); // Trim - from end of text
        if ((typeof separator !== 'undefined') && (separator !== '-')) {
            text = text.replace(/-/g, separator);
        }
        return text;
    }
};

app.init();

// for each IE fix
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


var map = null;
var markers = [];
var all_markers = [];
var markerCluster = null;
var zurla = true;

function initMap() {
    const mapDataLang = {
        pl: {
            start: {
                zoom: 11, minZoom: 7, center: new google.maps.LatLng(52.2, 21), // PL
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#bdbdbd"}]
                    },
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#757575"}]
                    },
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#616161"}]
                    },
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            geo: 'https://www.myfirststop.pl/api/geo_mfs_pl.js',
            closeText: 'ZAMKNIĘTE',
            openText: 'Godziny otwarcia',
            pnptText: 'pon.-pt.',
            satText: 'sob.',
            sunText: 'niedz.',
            routeText: 'Wyznacz trasę',
            phoneText: 'Zadzwoń',
            emailText: 'Napisz do nas'

        },
        cz: {
            start: {
                zoom: 8, minZoom: 6, center: new google.maps.LatLng(50.0719267, 14.4697382),   // CZ
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#bdbdbd"}]
                    },
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#757575"}]
                    },
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#616161"}]
                    },
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            geo: 'https://www.myfirststop.cz/api/geo_mfs_cz-jobs.js',
            closeText: 'ZAVŘENO',
            openText: 'Otevírací doba',
            pnptText: 'Po-Pá',
            satText: 'Sob',
            sunText: 'Ned',
            routeText: 'Vypočtěte trasu',
            phoneText: 'Telefon',
            emailText: 'Poslat Email'
        },
        sk: {
            start: {
                zoom: 8, minZoom: 6, center: new google.maps.LatLng(48.3519267, 18.3697382),   // SK
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#bdbdbd"}]
                    },
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#757575"}]
                    },
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#616161"}]
                    },
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            geo: 'assets/geo/geo_mfs_sk.js',
            closeText: 'ZAVŘENO',
            openText: 'OTEVŘENO DO',
            pnptText: 'pon.-pt.',
            satText: 'sob.',
            sunText: 'niedz.',
            routeText: 'Vypočtěte trasu',
            phoneText: 'Telefon',
            emailText: 'Poslat Email'
        },
        hu: {
            start: {
                zoom: 8, minZoom: 6, center: new google.maps.LatLng(47.535, 19.1), // HU
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#bdbdbd"}]
                    },
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#757575"}]
                    },
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#616161"}]
                    },
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            geo: '/api/geo_mfs_hu-jobs.js',
            closeText: 'ZÁRVA',
            openText: 'NYITVA ',
            pnptText: 'pon.-pt.',
            satText: 'sob.',
            sunText: 'niedz.',
            routeText: 'Útvonaltervező',
            phoneText: 'Hívás',
            emailText: 'Írj nekünk'
        },
        lt: {
            start: {
                zoom: 7, minZoom: 6, center: new google.maps.LatLng(55.1700284, 22.7623964), //LT
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#bdbdbd"}]
                    },
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#757575"}]
                    },
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#616161"}]
                    },
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            // geo: 'assets/geo/geo_mfs_lt.js',            // FST
            geo: 'assets/geo/geo_bp_lt.js',            // BP
            closeText: 'UŽDARYTA',
            openText: 'ATVIRAS',
            pnptText: 'pon.-pt.',
            satText: 'sob.',
            sunText: 'niedz.',
            // routeText: 'Apskaičiuokite maršrutą',
            routeText: '',
            phoneText: 'Telefon',
            emailText: 'Postal Email'
        },
        lv: {
            start: {
                zoom: 8, minZoom: 6, center: new google.maps.LatLng(56.8766564, 23.4231211),   // L
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#bdbdbd"}]
                    },
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#757575"}]
                    },
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#616161"}]
                    },
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            geo: 'assets/geo/geo_mfs_lv.js',        // FST
            // geo: 'assets/geo/geo_bp_lv.js',        // BP
            closeText: 'SLĒGTS',
            openText: 'OTEVŘENO DO',
            pnptText: 'pon.-pt.',
            satText: 'sob.',
            sunText: 'niedz.',
            // routeText: 'Aprēķiniet maršrutu',
            routeText: '',
            phoneText: 'Tālrunis',
            emailText: 'E-pasts'
        },
        ee: {
            start: {
                zoom: 8, minZoom: 6, center: new google.maps.LatLng(59, 26),   // EE
                styles: [
                    {"elementType": "geometry", "stylers": [{"color": "#f5f5f5"}]},
                    {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                    {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"}]},
                    {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"}]},
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#bdbdbd"}]
                    },
                    {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"}]},
                    {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"}]},
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#757575"}]
                    },
                    {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"}]},
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#616161"}]
                    },
                    {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]},
                    {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"}]},
                    {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"}]},
                    {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"}]},
                    {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"}]}
                ],
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scrollwheel: false
            },
            geo: 'assets/geo/geo_mfs_ee.js',     // dla First Stop
            // geo: 'assets/geo/geo_bp_ee.js',         // dla Business Partner
            closeText: 'SULETUD',
            openText: 'OTEVŘENO DO',
            pnptText: 'pon.-pt.',
            satText: 'sob.',
            sunText: 'niedz.',
            // routeText: 'Arvuta teekond',
            routeText: '',
            phoneText: 'Telefon',
            emailText: 'Email'
        }
    };

    let mapData;

    if (app.checkLangue() === 'pl') {
        mapData = mapDataLang.pl;
    }

    if (app.checkLangue() === 'cz') {
        mapData = mapDataLang.cz;
    }

    if (app.checkLangue() === 'hu') {
        mapData = mapDataLang.hu;
    }

    if (app.checkLangue() === 'ee') {
        mapData = mapDataLang.ee;
    }

    if (app.checkLangue() === 'lv') {
        mapData = mapDataLang.lv;
    }

    if (app.checkLangue() === 'lt') {
        mapData = mapDataLang.lt;
    }

    $("#map").fadeTo(0, 0);
    map = new google.maps.Map(document.getElementById('map'), mapData.start);


    // // Create the DIV to hold the control and call the CenterControl()
    // // constructor passing in this DIV.
    // var centerControlDiv = document.createElement('div');
    // var centerControl = new CenterControl(centerControlDiv, map);

    // centerControlDiv.index = 1;
    // map.controls[google.maps.ControlPosition.TOP_LEFT].push(centerControlDiv);


    var input = document.getElementById('searchinput');
    var searchBox = new google.maps.places.SearchBox(input);

    document.getElementById('searchbutton').onclick = function () {
        google.maps.event.trigger(input, 'focus');
        google.maps.event.trigger(input, 'keydown', {keyCode: 13});
    };

    map.addListener('bounds_changed', function () {
        searchBox.setBounds(map.getBounds());
    });

    searchBox.addListener('places_changed', function () {
        var places = searchBox.getPlaces();

        if (places.length == 0) {
            return;
        }

        var bounds = new google.maps.LatLngBounds();

        places.forEach(function (place) {
            if (!place.geometry) {
                console.log("Returned place contains no geometry");
                return;
            }
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport);
            } else {
                bounds.extend(place.geometry.location);
            }
        });
        map.fitBounds(bounds);
    });

    var script = document.createElement('script');
    script.src = mapData.geo;

    document.getElementsByTagName('head')[0].appendChild(script);

    function isLinkExpiryDateWithinRange(monfri, sat) {

        var now = new Date();
        var day = now.getDay();
        var value = '';

        switch (day) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                if (!monfri) return '';
                value = monfri.split(/[-:]/);
                break;
            case 6:
                if (!sat) return '';
                value = sat.split(/[-:]/);
                break;
            default:
                return mapData.closeText;
        }

        if (
            (
                parseInt(now.getHours()) > parseInt(value[0])
                ||
                (
                    parseInt(now.getHours()) == parseInt(value[0])
                    &&
                    parseInt(now.getMinutes()) >= parseInt(value[1])
                )
            )
            &&
            (
                parseInt(now.getHours()) < parseInt(value[2])
                ||
                (
                    parseInt(now.getHours()) == parseInt(value[2])
                    &&
                    parseInt(now.getMinutes()) <= parseInt(value[3])
                )
            )
        )
            return '<span style="color: #3bb311">' + mapData.openText + ' ' + value[2] + ':' + value[3] + '</span>';
        else
            return mapData.closeText;
    }

    window.eqfeed_callback = function (results) {
        for (var i = 0; i < results.features.length; i++) {
            var coords = results.features[i].geometry.coordinates;
            var latLng = new google.maps.LatLng(coords[1], coords[0]);
            var marker = new google.maps.Marker({
                icon: 'assets/img/ic_poi3.png',
                position: latLng,
                // map: map,
                name: results.features[i].properties.name,
                address: results.features[i].properties.city + ', ' + results.features[i].properties.street,
                phone: results.features[i].properties.phone,
                email: results.features[i].properties.email,
                monfri: results.features[i].properties.monfri,
                sat: results.features[i].properties.sat,
                sun: results.features[i].properties.sun,
                animation: google.maps.Animation.DROP
            });

            var content = '<div class="poi">' +
                // '<p class="poi__firststop"></p>' +
                '<p class="poi__head">' + marker.name + '</p>' +
                '<p class="poi__addr">' + marker.address + '</p>' +
                // '<p class="poi__addr">' + marker.email + '</p>' +
                '<p style="padding-top:1rem;margin-bottom:0"><strong>' + mapData.openText + '</strong>' +
                '<table class="unstriped" style="width:auto;border:0"><tbody style="border:0"><tr style="border:0"><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + mapData.pnptText + '</td><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + marker.monfri + '</td></tr>' +
                '<tr style="border:0"><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + mapData.satText + '</td><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + marker.sat + '</td></tr>' +
                '<tr style="border:0"><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + mapData.sunText + '</td><td style="padding: 0 1rem 0.3rem 0;font-size:95%">' + marker.sun + '</td></tr></tbody></table>' +
                // '<p style="padding-top:1rem"><strong>' + isLinkExpiryDateWithinRange(marker.monfri, marker.sat) + '</strong></p>' +
                '<p><a class="cta_showaddress" data-street="' + results.features[i].properties.street + '">' + mapData.routeText + '</a></p>' +
                '<a id="ga_phone_' + app.slugify(marker.name) + '" class="cta_phone" data-phone="' + marker.phone + '">' + mapData.phoneText + '</a>' +
                '<a id="ga_email_' + app.slugify(marker.name) + '" href="mailto:' + marker.email + '" class="cta_visit" target="_blank">' + mapData.emailText + '</a>' +
                // '<a href="mailto:' + marker.email + '" class="cta_visit" target="_blank">' + mapData.emailText + '</a>' +
                '</div>';

            var infowindow = new google.maps.InfoWindow();

            var directionsService = new google.maps.DirectionsService;
            var directionsDisplay = new google.maps.DirectionsRenderer;

            google.maps.event.addListener(marker, 'click', (function (marker, content, infowindow) {
                return function () {
                    infowindow.setContent(content);
                    infowindow.open(map, marker);
                    // google.maps.event.addListener(map, 'mousemove', function () {
                    //     infowindow.close();
                    // });
                    $(document).on('click', '.poi', function(event){
                        infowindow.close();
                    });

                    setTimeout(function () {
                        $(".cta_phone").click(function () {
                            Swal.fire({
                                html: "<a id='ga_call_" + app.slugify(marker.name) + "' href='tel:" + this.dataset.phone + "' style='font-size:2rem'>" + this.dataset.phone + "</a>",
                                showConfirmButton: false,
                                showCloseButton: true
                            });
                        });
                        $(".cta_showaddress").click(function () {

                            function showPosition(position) {

                                directionsService.route({
                                    origin: position.coords.latitude + ',' + position.coords.longitude,
                                    destination: marker.address,
                                    travelMode: 'DRIVING'
                                }, function (response, status) {
                                    if (status === 'OK') {
                                        directionsDisplay.setDirections(response);

                                        directionsDisplay.setMap(map);
                                    } else {
                                        window.alert('Directions request failed due to ' + status);
                                    }
                                });
                            }

                            var $ua = window.navigator.userAgent.toLowerCase();

                            if (($ua.indexOf('iphone') > -1)
                                || ($ua.indexOf('ipad') != -1)
                                || ($ua.indexOf('ipod') != -1)
                                || ($ua.indexOf('android') != -1)
                                || ($ua.indexOf('playbook') != -1)) {
                                window.location = 'http://maps.apple.com/?saddr=My+Location&daddr=' + marker.address;
                            } else {
                                navigator.geolocation.getCurrentPosition(showPosition);
                            }

                        });
                    }, 50);
                };
            })(marker, content, infowindow));

            markers.push(marker);
        }
        all_markers = markers;
        markerCluster = new MarkerClusterer(map, markers, {imagePath: 'assets/img/m'});
    };

    google.maps.event.addListener(map, 'idle', function () {

        $("#map").fadeTo("slow", 1);

        function getRequests() {
            var s1 = location.search.substring(1, location.search.length).split('&'),
                r = {}, s2, i;
            for (i = 0; i < s1.length; i += 1) {
                s2 = s1[i].split('=');
                r[decodeURIComponent(s2[0]).toLowerCase()] = decodeURIComponent(s2[1]);
            }
            return r;
        };
        var QueryString = getRequests();

        if (zurla === true && typeof QueryString["q"] !== 'undefined') {
            var input = document.getElementById('searchinput');
            input.value = QueryString["q"];
            $('#searchbutton').trigger("click");
            zurla = false;
        }

    });

    google.maps.event.addListener(map, 'idle', function () {
        $('#map').find('.gmnoprint > div').css('background', '#ed1c24');
    });

    new AutocompleteDirectionsHandler(map);
}


function AutocompleteDirectionsHandler(map) {
    this.map = map;
    this.originPlaceId = null;
    this.destinationPlaceId = null;
    this.travelMode = 'DRIVING';
    var originInput = document.getElementById('origin-input');
    var destinationInput = document.getElementById('destination-input');
    var modeSelector = document.getElementById('mode-selector');
    this.directionsService = new google.maps.DirectionsService;
    this.directionsDisplay = new google.maps.DirectionsRenderer;
    this.directionsDisplay.setMap(map);

    var originAutocomplete = new google.maps.places.Autocomplete(
        originInput, {place_id: true});
    var destinationAutocomplete = new google.maps.places.Autocomplete(
        destinationInput, {place_id: true});

    this.setupClickListener('changemode-walking', 'WALKING');
    this.setupClickListener('changemode-transit', 'TRANSIT');
    this.setupClickListener('changemode-driving', 'DRIVING');

    this.setupPlaceChangedListener(originAutocomplete, 'ORIG');
    this.setupPlaceChangedListener(destinationAutocomplete, 'DEST');

    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(originInput);
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(destinationInput);
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(modeSelector);
}

AutocompleteDirectionsHandler.prototype.setupClickListener = function (id, mode) {
    var radioButton = document.getElementById(id);
    var me = this;
    radioButton.addEventListener('click', function () {
        me.travelMode = mode;
        me.route();
    });
};

AutocompleteDirectionsHandler.prototype.setupPlaceChangedListener = function (autocomplete, mode) {
    var me = this;
    autocomplete.bindTo('bounds', this.map);
    autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace();
        if (!place.place_id) {
            window.alert("Please select an option from the dropdown list.");
            return;
        }
        if (mode === 'ORIG') {
            me.originPlaceId = place.place_id;
        } else {
            me.destinationPlaceId = place.place_id;
        }
        me.route();
    });

};

AutocompleteDirectionsHandler.prototype.route = function () {
    if (!this.originPlaceId || !this.destinationPlaceId) {
        return;
    }
    var me = this;

    this.directionsService.route({
        origin: {'placeId': this.originPlaceId},
        destination: {'placeId': this.destinationPlaceId},
        travelMode: this.travelMode
    }, function (response, status) {
        if (status === 'OK') {
            me.directionsDisplay.setDirections(response);
        } else {
            window.alert('Directions request failed due to ' + status);
        }
    });

};

function showVisibleMarkers(map) {

    var bounds = map.getBounds();
    var count = 0;

    $('#pushpois').html('');

    for (var i = 0; i < markers.length; i++) {
        var marker = markers[i];
        var infoPanel = $('.info-' + (i + 1));

        if (bounds.contains(marker.getPosition()) === true) {
            infoPanel.show();

            count++;
        } else {
            infoPanel.hide();
        }
    }
    // console.log(count);
}


$('#useMyLocation').click(function () {
    initMap();
    return false;
});


window.initMap = initMap;

$(".tooltip").on("click", function () {
    $(this).foundation('hide');
});

const toggleRadios = document.querySelectorAll('.toggle-radios');

toggleRadios.forEach(function (el) {
    el.addEventListener('click', function (e) {
        if (e.target && e.target.type == 'radio') {
            e.target.parentElement.classList.add('active');
            if (e.target.parentElement.previousElementSibling) {
                e.target.parentElement.previousElementSibling.classList.remove('active');
            }
            if (e.target.parentElement.nextElementSibling) {
                e.target.parentElement.nextElementSibling.classList.remove('active');
            }
        }
    });
});

// radios yes and no

const submitBtn = document.querySelector("#sendbutton");

function confirmRadios() {
    // submitBtn.removeAttribute('disabled');
    //     more.classList.remove("hide");
    // const tak = document.querySelector('#tak');
    // const nie = document.querySelector('#nie');
    // const more = document.querySelector('.more-confirm');
    // tak.addEventListener('click', agreed);
    // nie.addEventListener('click', disagreed);

    // function agreed() {
    //     tak.classList.add('active');
    //     nie.classList.remove('active');
    //     submitBtn.removeAttribute('disabled');
    //     more.classList.remove("hide");
    //     // errorMsg.classList.add('hide')
    // }

    // function disagreed() {
    //     tak.classList.remove('active');
    //     nie.classList.add('active');
    //     submitBtn.setAttribute('disabled', '');
    //     more.classList.add("hide");
    //     // errorMsg.classList.remove('hide')
    // }
}

if ((app.checkLangue() === 'pl') || (app.checkLangue() === 'ee') || (app.checkLangue() === 'lv') || (app.checkLangue() === 'lt')) {
    confirmRadios();
}

// komunikaty na popupie

const swallMessagesData = {
    pl: {
        success: {
            title: `Dziękujemy za zgłoszenie.`,
            html: `<p> Dziękujemy za zgłoszenie.<br> Właśnie wysłaliśmy do
            Ciebie maila. Pamiętaj, aby potwierdzić zgłoszenie
            klikając w link weryfikacyjny zawarty w wiadomości.<br>
            Bez tego Twoje zgłoszenie nie zostanie przyjęte.</p>`,
        },

        error: {
            title: 'Twój email jest już na liście',
        },

        confirmSucces: {
            title: "Twój numer banku został zapisany"
        },

        bankSucces: {
            title: "Twój numer banku został zapisany"
        }
    },
    cz: {
        success: {
            title: `DĚKUJEME ZA PŘIHLÁŠENÍ`,
            html: `<p></p>`,
        },

        error: {
            title: 'Váš e-mail je již na seznamu.',
        },
    },
    sk: {
        success: {
            title: `Děkujeme za hlášení.`,
            html: `<p> Doklad o koupi je ověřen. <br> Po ověření obdržíte kupon First Stop.</p>`,
        },

        error: {
            title: 'Váš e-mail je už na zozname',
        },
    },
    hu: {
        success: {
            title: `Köszönjük!`,
            html: `<p>Regisztrációja sikeres volt. A feltöltött számláját hamarosan ellenőrizzük, Extra Garanciájának életbe lépéséről, annak jóváhagyását követően küldünk üzenetet az Ön által megadott e-mail címre!</p>`,
        },

        error: {
            title: 'Ez az e-mail cím már használatban van.',
        },
    },
    lt: {
        success: {
            title: `AČIŪ, KAD TAIKOMAS`,
            html: `<p></p>`,
        },

        error: {
            title: 'Jūsų el Paštas jau yra sąraše',
        },
    },
    lv: {
        success: {
            title: `PALDIES, JŪSU PIETEIKUMS IR PIEŅEMTS`,
            html: `<p></p>`,
        },

        error: {
            title: 'Jūsu e-pasts jau ir sarakstā',
        },
    },
    ee: {
        success: {
            title: `Täname, teie avaldus on vastu võetud`,
            html: ``,
        },

        error: {
            title: 'Teie e-maili aadress on juba registreeritud',
        },
    }
};

let swallMessage;

if (app.checkLangue() === 'pl') {
    swallMessage = swallMessagesData.pl;
}

if (app.checkLangue() === 'cz') {
    swallMessage = swallMessagesData.cz;
}

if (app.checkLangue() === 'sk') {
    swallMessage = swallMessagesData.sk;
}

if (app.checkLangue() === 'hu') {
    swallMessage = swallMessagesData.hu;
}

if (app.checkLangue() === 'lv') {
    swallMessage = swallMessagesData.lv;
}

if (app.checkLangue() === 'lt') {
    swallMessage = swallMessagesData.lt;
}

if (app.checkLangue() === 'ee') {
    swallMessage = swallMessagesData.ee;
}
//TODO: usunąć nazwę pliku po wyłaniu formularza

// TODO: dodać obsługę odblokowania buttona po zaznaczeniu zgód
if (app.checkLangue() === 'cz') {
    submitBtn.removeAttribute('disabled');
}

// NuLead

// TODO rozwinąć to na cały tekst na stronie;
const headerToFix = document.querySelector(`.kv-section h4`);
let txt = headerToFix.textContent.trim();

headerToFix.innerHTML = txt;

let nuLead = {
    GUID: '',
    LID: '',
    email: ''
};

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

// getID
const url = window.location.href;
const linkLID = getQueryVariable('lid');

// nuLead.GUID = '8bcda72e61a835a804b396f9894fb101';
nuLead.LID = linkLID;

const leadData = `{"LID" : "` + linkLID + `"}`;

// Sprawdzanie LIDa w linku
if (/^([a-z0-9]{32,})$/.test(linkLID)) {

    nulead.getJSON('8bcda72e61a835a804b396f9894fb101', leadData,
        function (data) {
            console.log(data);
            let incoming = data;

            if (incoming.LeadStatusName === 'Validated') {
                Swal.fire({
                    title: 'Dziękujemy!',
                    html: `<p>Twoje zgłoszenie zostało potwierdzone.</p>`,
                    type: 'success',
                    confirmButtonText: 'OK'
                });
            }

            if (incoming.LeadStatusName === 'Pending') {
                $('.file-upload_result').text(incoming.file1).prop('disabled', true);
                $('#receipt').prop('required', false);
                $('#receipt').removeAttr('data-validation');
                $('#receipt').removeAttr('name');
                $('#input_firstname').val(incoming.firstname).addClass('has-content').prop('disabled', true);
                $('#input_lastname').val(incoming.lastname).addClass('has-content').prop('disabled', true);
                $('#input_email').val(incoming.email).addClass('has-content').prop('disabled', true);
                $('#input_phone').val(incoming.phone).addClass('has-content').prop('disabled', true);
                if (incoming.bank_number !== "") {
                    $('#input_bank_number').val(incoming.bank_number).addClass('has-content').prop('disabled', true);
                }
                if (incoming.name_service !== "") {
                    $('#input_name_service').val(incoming.name_service).addClass('has-content').prop('disabled', true);
                }

                Swal.fire({
                    title: 'Witaj!',
                    html: `<p>Podaj nr swojego konta</p>`,
                    type: 'success',
                    confirmButtonText: 'OK'
                });

                // Wysłanie numeru bankowego.
                $('#addlead').submit(function (event) {
                    event.preventDefault();
                    if (!checkValidation()) {
                        var form = new FormData($(this)[0]);
                        form.append('LID', incoming.LID);
                        form.append('LeadHref', window.location.href);
                        form.append('LeadReferrer', document.referrer);
                        form.append('LeadUA', navigator.userAgent);
                        console.log(form);
                        $(".loader").css("display", "block");
                        form.append('LeadIP', $.ajax({
                            type: 'GET',
                            url: 'https://www.nulead.pl/ip.php',
                            async: false
                        }).responseText);

                        var object = {};                                        // sprawdzenie wysyłanyh danych
                        form.forEach(function (value, key) {
                            object[key] = value;
                        });
                        var json = JSON.stringify(object);

                        $.ajax({
                            url: 'https://api.nulead.pl/set',
                            type: 'POST',
                            data: form,
                            processData: false,
                            contentType: false,
                        }).done(function (data) {
                            const incData = JSON.parse(data);
                            console.log(incData);

                            if (incData.status == 'error') {
                            } else {
                                $('#addlead').trigger('reset');
                                $("output").text(" ");
                                nulead.update(nuLead.GUID, nuLead.LID, {LeadStatusName: 'Completed'}, function (data) {
                                    console.log(data);
                                });

                                Swal.fire({
                                    title: 'Dziękujemy!',
                                    html: `<p>Numer Twojego konta został zapisany.</p>`,
                                    type: 'success',
                                    confirmButtonText: 'OK'
                                });
                            }

                            $(".loader").css("display", "none");
                        });
                    }
                });
            }
        });
} else {
    $('#addlead').submit(function (event) {
        event.preventDefault();
        console.log('test');

        if (!checkValidation()) {
            var form = new FormData($(this)[0]);
            // form.append('LeadStatusId', '23');
            // form.append('LeadHref', window.location.href);
            // form.append('LeadReferrer', document.referrer);
            // form.append('LeadUA', navigator.userAgent);
            // form.append('LeadIP', $.ajax({ type: 'GET', url: 'https://www.nulead.pl/ip.php', async: false }).responseText);
            console.log(form);
            $.ajax({
                url: 'https://api.nulead.pl/set',
                type: 'POST',
                data: form,
                processData: false,
                contentType: false
            }).done(function (data) {
                const incData = JSON.parse(data);
                console.log(incData);

                if (incData.status == 'error') {
                    console.log('formularz nie wysłany');
                    Swal.fire({

                        // title: 'Twój email jest już na liście',
                        title: swallMessage.error.title,
                        // html: '<p> Trwa weryfikacja dowodu zakupu. <br> Po weryfikacji otrzymasz kupon rabatowy First Stop na podany adres e-mail.</p>',
                        type: 'error',
                        confirmButtonText: 'OK'
                    })
                } else {
                    console.log('formularz wysłany');
                    $('#addlead').trigger('reset');
                    $("output").text(" ");
                    Swal.fire({

                        title: swallMessage.success.title,
                        html: swallMessage.success.html,
                        type: 'success',
                        confirmButtonText: 'OK'
                    })
                }
            });
        }
    });
}


// sprawdzanie validacji

function checkValidation() {
    const requiersInputs = document.querySelectorAll('input:required');
    let error = false;
    requiersInputs.forEach(function (el) {
        if (el.classList.contains === 'error') {
            console.log(el);
            error = true;
        }
    });
    console.log(error);
    return error;

};

// to testów nowej promocji
$('#testsubmit').submit(function (event) {
    event.preventDefault();
    Swal.fire({
        title: swallMessage.success.title,
        html: swallMessage.success.html,
        type: 'success',
        confirmButtonText: 'OK'
    })
});